<template>
  <div>
    <v-row class="mb-4">
      <v-col>
        <h3 class="text-h6 font-weight-medium mb-4">
          Security
        </h3>
        <p class="text--secondary">
          Manage your security settings and two-factor authentication.
        </p>
      </v-col>
    </v-row>
    <!-- Security settings will be implemented here -->
    <div class="text-center py-8 text--secondary">
      Security settings coming soon...
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsSecurity',
  props: {
    security: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
